import React, { useState } from "react";

const Mission = () => {
  // "mission" | "outreach" | "zion"
  const [open, setOpen] = useState("mission");

  const toggle = (key) => {
    setOpen((prev) => (prev === key ? null : key));
  };

  const isOpen = (key) => open === key;

  return (
    <section id="mission" className="container-fluid g-px-0">
      <section className="container g-pt-50 g-pb-25">
        <div className="row">
          <div className="col-md-12 g-mb-25">
            <section className="g-py-25">
              <div
                className="u-accordion u-accordion-bg-primary u-accordion-color-white"
                role="tablist"
                id="accordion-11"
              >
                {/* Mission */}
                <div className="card g-brd-none rounded-0 g-mb-15">
                  <div
                    className="u-accordion__header g-pa-0"
                    id="mission-header"
                    role="tab"
                  >
                    <h5 className="mb-0">
                      <button
                        type="button"
                        className={`d-flex w-100 g-color-main g-pa-10-15 ${
                          isOpen("mission") ? "" : "collapsed"
                        }`}
                        onClick={() => toggle("mission")}
                        aria-expanded={isOpen("mission") ? "true" : "false"}
                        aria-controls="mission-body"
                        style={{
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                        }}
                      >
                        <span className="u-accordion__control-icon g-mr-10">
                          <i className="fa fa-angle-down" />
                          <i className="fa fa-angle-up" />
                        </span>
                        Our Mission &amp; Vision
                      </button>
                    </h5>
                  </div>

                  <div
                    id="mission-body"
                    className={`collapse ${isOpen("mission") ? "show" : ""}`}
                    role="tabpanel"
                    aria-labelledby="mission-header"
                  >
                    <div className="u-accordion__body g-color-gray-dark-v5">
                      <h3>Our Mission</h3>
                      <p>
                        The mission of Bishop K.J. Brown Ministries is that, through
                        the preaching and teaching of the gospel, a multitude of men,
                        women, boys, and girls will come to know the Lord Jesus Christ
                        as Savior. We are called to &quot;build winning lives&quot; by
                        sharing the life–changing truth of God&apos;s Word in a way that
                        is practical, relevant, and full of grace.
                      </p>
                      <p>
                        We also endeavor to be a source of encouragement, inspiration,
                        and spiritual strength to those who already know the Lord and
                        desire to grow in their relationship with Him. Every message,
                        ministry, and outreach effort is designed to help believers
                        live victoriously in Christ.
                      </p>

                      <h3>The Vision</h3>
                      <p>
                        Our vision is to raise up a church that is a light in the world,
                        not just a local assembly but a strong part of the Body of
                        Christ. We desire to be:
                      </p>
                      <ul>
                        <li>Strength for the weary,</li>
                        <li>Hope for the worn,</li>
                        <li>Healing for the wounded,</li>
                        <li>Encouragement for the well,</li>
                      </ul>
                      <p>
                        as we patiently await the return of Jesus Christ our Lord. We
                        have a multi–year plan to move from meeting room rental to
                        leased space, and ultimately to a permanent facility for Zion
                        Tabernacle Church and Bishop K.J. Brown Ministries.
                      </p>
                      <p>
                        You can partner with us by sowing a monthly gift of $33.00 to
                        <strong> Project Zion 33</strong>. Your support helps us move
                        from vision to reality, creating a place where lives can be
                        transformed for generations to come.
                      </p>
                      <h5 className="g-mt-15">
                        <strong>Plan – Raise – Buy – Build – Grow</strong>
                      </h5>
                      <p className="g-mt-10">
                        Support us in stewardship:{" "}
                        <a
                          href="https://tithe.ly/give?c=278656"
                          className="g-color-blue"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Partner with Us
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                {/* Outreach */}
                <div className="card g-brd-none rounded-0 g-mb-15">
                  <div
                    className="u-accordion__header g-pa-0"
                    id="outreach-header"
                    role="tab"
                  >
                    <h5 className="mb-0">
                      <button
                        type="button"
                        className={`d-flex w-100 g-color-main g-pa-10-15 ${
                          isOpen("outreach") ? "" : "collapsed"
                        }`}
                        onClick={() => toggle("outreach")}
                        aria-expanded={isOpen("outreach") ? "true" : "false"}
                        aria-controls="outreach-body"
                        style={{
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                        }}
                      >
                        <span className="u-accordion__control-icon g-mr-10">
                          <i className="fa fa-angle-down" />
                          <i className="fa fa-angle-up" />
                        </span>
                        Outreach Ministry
                      </button>
                    </h5>
                  </div>

                  <div
                    id="outreach-body"
                    className={`collapse ${isOpen("outreach") ? "show" : ""}`}
                    role="tabpanel"
                    aria-labelledby="outreach-header"
                  >
                    <div className="u-accordion__body g-color-gray-dark-v5">
                      <p>
                        Our Outreach Ministry is committed to extending the love of Christ
                        beyond the walls of the church. We strive to meet both spiritual
                        and practical needs through prayer, evangelism, community support,
                        and compassionate service.
                      </p>
                      <p>
                        Whether it is ministering to the hurting, feeding those in need,
                        or sharing the gospel one–on–one, our heart is to be the hands and
                        feet of Jesus in our community and beyond.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Zion Church */}
                <div className="card g-brd-none rounded-0">
                  <div
                    className="u-accordion__header g-pa-0"
                    id="zion-header"
                    role="tab"
                  >
                    <h5 className="mb-0">
                      <button
                        type="button"
                        className={`d-flex w-100 g-color-main g-pa-10-15 ${
                          isOpen("zion") ? "" : "collapsed"
                        }`}
                        onClick={() => toggle("zion")}
                        aria-expanded={isOpen("zion") ? "true" : "false"}
                        aria-controls="zion-body"
                        style={{
                          background: "transparent",
                          border: "none",
                          textAlign: "left",
                        }}
                      >
                        <span className="u-accordion__control-icon g-mr-10">
                          <i className="fa fa-angle-down" />
                          <i className="fa fa-angle-up" />
                        </span>
                        Zion Tabernacle Church
                      </button>
                    </h5>
                  </div>

                  <div
                    id="zion-body"
                    className={`collapse ${isOpen("zion") ? "show" : ""}`}
                    role="tabpanel"
                    aria-labelledby="zion-header"
                  >
                    <div className="u-accordion__body g-color-gray-dark-v5">
                      <p>
                        Zion Tabernacle Church is a Bible–based church in southwest
                        Houston, led by Bishop K.J. Brown. Our focus is on building
                        strong families, developing mature believers, and equipping
                        disciples to impact their world for Christ.
                      </p>
                      <p>
                        We invite you to worship with us, experience the presence of God,
                        and grow with a loving church family that is committed to
                        &quot;Building Winning Lives.&quot;
                      </p>
                      <a
                        href="https://www.ztchurch.org/"
                        className="btn btn-xl u-btn-primary text-uppercase"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Visit Zion Tabernacle Church
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>
    </section>
  );
};

export default Mission;
